import { useEffect } from 'react';
import { Button, Group, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { reportLocalRecordingEvent } from './metrics';
import {
    downloadRecording,
    forgetRecording,
    listUnsavedRecordings,
    markRecordingSaved,
    recordingFileName,
    type UnsavedRecording,
} from './storage';
import { i18n } from '@/i18n';

function showRecovery({ meta, file }: UnsavedRecording) {
    const id = `local-recording-${meta.id}`;
    const name = recordingFileName(meta);
    notifications.show({
        id,
        autoClose: false,
        color: 'warning',
        title: i18n.t('conference:localRecording.recovery.title'),
        message: (
            <Stack gap="var(--spacing-2)">
                <Text size="sm">
                    {i18n.t('conference:localRecording.recovery.message', {
                        name,
                        size: (file.size / 1024 / 1024).toFixed(1),
                    })}
                </Text>
                <Group gap="var(--spacing-2)">
                    <Button
                        size="sm"
                        onClick={() => {
                            downloadRecording(file, name);
                            markRecordingSaved(meta);
                            reportLocalRecordingEvent('recovered');
                            notifications.hide(id);
                        }}
                    >
                        {i18n.t('conference:localRecording.recovery.download')}
                    </Button>
                    <Button
                        color="danger"
                        size="sm"
                        variant="default"
                        onClick={() => {
                            void forgetRecording(meta);
                            notifications.hide(id);
                        }}
                    >
                        {i18n.t('conference:localRecording.recovery.discard')}
                    </Button>
                </Group>
            </Stack>
        ),
    });
}

export function LocalRecordingRecovery() {
    useEffect(() => {
        listUnsavedRecordings()
            .then((recordings) => {
                for (const recording of recordings) showRecovery(recording);
            })
            .catch((error: unknown) => {
                console.warn('Unsaved local recordings were not listed', error);
            });
    }, []);
    return null;
}
